import { useAtom } from "jotai";
import { get } from "lodash";
import { useEffect, useCallback } from "react";
import { zoomAreaAtom } from "../atoms";
import { CHART_TYPE } from './utils';

// all timeseries will sync on slice zoom action
// distribution zoom will be independent
function useZoom({ instance, chartMode, enabled }) {

  const [zoomArea, setZoomArea] = useAtom(zoomAreaAtom);

  // handle chart zoom action
  const handleZoom = useCallback((zoomValue) => {
    if (instance) {

      instance.dispatchAction({
        type: 'dataZoom',
        dataZoomIndex: 0,
        ...zoomValue,
      });

      // clear brush selection
      instance.dispatchAction({
        type: 'brush',
        command: 'clear',
        areas: [],
      });
    }
  }, [instance]);

  // trigger action when slice ends
  const handleBrushEnd = useCallback((burshData) => {
    const range = get(burshData, ['areas', '0', 'coordRange'], null);
    const option = instance.getOption();

    if (range) {
      const zoomValue = {
        // data value at starting location
        startValue: Math.floor(range[0]),
        // data value at ending location
        endValue: Math.ceil(range[1]),
      }

      if (option._viewType === 'timeseries') {
        setZoomArea(zoomValue);
      } else {
        handleZoom(zoomValue);
      }
    }
  }, [instance, handleZoom]);

  // register chart events
  useEffect(() => {
    if (instance) {
      if (enabled) {
        // slice to zoom
        instance.on('brushEnd', handleBrushEnd);
      }

      // off on unmount
      return () => {
        instance.off('brushEnd', handleBrushEnd);
      }
    }
  }, [handleBrushEnd, instance, enabled]);


  // triggers even if the hook is not enabled to persist state value on chart
  useEffect(() => {
    if (zoomArea && [CHART_TYPE.LINE, CHART_TYPE.BAR].includes(chartMode)) {
      handleZoom(zoomArea);
    }
  }, [instance, chartMode, handleZoom, zoomArea]);

}

export default useZoom;
